import React from 'react'
import SectionInformation from '@/components/public/SectionInformation'

export type PublicRegistrationWrapperProps = {
	descriptionParagraphs: string[]
	successParagraphs?: string[]
	isSubmitted?: boolean
	children?: React.ReactNode
}

export default function PublicRegistrationWrapper(props: PublicRegistrationWrapperProps) {
	const { descriptionParagraphs, successParagraphs = [], isSubmitted = false, children } = props

	if (isSubmitted) return <SectionInformation paragraphs={successParagraphs} />

	return <SectionInformation paragraphs={descriptionParagraphs}>{children}</SectionInformation>
}

export {}
